import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";

import * as XLSX from "xlsx";
const CommissionLedgerReport = ({ mid }) => {
    const { callApi: Commissionledgerreport } = useApi(
        "/ledger/commission",
        "GET"
    );


    const [applyLoader, setApplyLoader] = useState(false);

    const [downloadLoader, setDownloadLoader] = useState(false);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const today = formatDate(new Date());


    const [history, setHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize] = useState(20);

    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const [loading, setLoading] = useState(false);

    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);

    // ✅ FETCH API
    const fetchCommissionLedger = async (targetPage = 0, loadMore = false) => {
        if (!mid) return;

        setLoading(true);

        try {
            const query = `?bid=${mid}&page=${targetPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}`;

            const res = await Commissionledgerreport(null, query);
            const data = (res?.content || []).filter(Boolean);

            setTotalPages(res?.totalPages || 0);
            setTotalElements(res?.totalElements || 0);

            setHistory((prev) =>
                loadMore ? [...prev, ...data] : data
            );

            setPage(targetPage);
        } catch (err) {
            console.error(err);
            if (!loadMore) setHistory([]);
        } finally {
            setLoading(false);
        }
    };

    // ✅ INITIAL LOAD
    useEffect(() => {
        fetchCommissionLedger(0);
    }, [mid]);

    // ✅ NET AMOUNT FORMAT
    const formatNetAmount = (value, row) => {
        if (row.txnType === "CREDIT" || row.txnType === "Approved") {
            return (
                <span className="font-semibold text-green-700">
                    ₹{value?.toFixed(2)}
                </span>
            );
        }

        if (row.txnType === "DEBIT") {
            return (
                <span className="font-semibold text-red-600">
                    ₹{value?.toFixed(2)}
                </span>
            );
        }

        if (row.txnType === "REFUND") {
            return (
                <span className="font-semibold text-yellow-700 bg-yellow-50 px-2 py-0.5 rounded">
                    ₹{value?.toFixed(2)}
                </span>
            );
        }

        return <span className="text-gray-400">—</span>;
    };



    // const downloadExcel = () => {
    //     const rows = history.map((r) => ({
    //         TxnID: r.txnId,
    //         Date: r.txnDate,
    //         Aadhaar: r.narration,
    //         TxnAmount: r.txnAmount,
    //         NetAmount: r.netAmount,
    //         Charges: r.charges,
    //         Cashback: r.cashback,
    //         Commission: r.commission,
    //         TDS: r.tds,
    //         Balance: r.balance,
    //         Shopname: r.shopName,
    //         Status: r.txnType,
    //     }));

    //     const ws = XLSX.utils.json_to_sheet(rows);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Commision Ledger Report");
    //     XLSX.writeFile(wb, "Commission_Ledger_Report.xlsx");
    // };

    const downloadExcel = async () => {
        try {
            if (!mid) return;
            setDownloadLoader(true)

            let allData = [];
            let currentPage = 0;
            let totalPagesLocal = 1;

            const safePageSize = pageSize && pageSize > 0 ? pageSize : 10;

            while (currentPage < totalPagesLocal) {
                const query = `?bid=${mid}&page=${currentPage}&size=${safePageSize}&fromDate=${fromDate}&toDate=${toDate}`;

                // FIXED: Correct API function name
                const res = await Commissionledgerreport(null, query);

                const data = res?.content || [];

                allData = [...allData, ...data];
                totalPagesLocal = res?.totalPages || 1;

                currentPage++;
            }

            if (allData.length === 0) {
                alert("No data available to download.");
                return;
            }

            const rows = allData.map((r) => ({
                TxnID: r.txnId,
                Date: new Date(r.txnDate).toLocaleString("en-IN"),
                Narration: r.narration,
                ShopName: r.shopName,
                Commission: r.commission,
                TDS: r.tds,
                NetAmount: r.netAmount,
                Balance: r.balance,
                Status: r.txnType,
            }));

            const ws = XLSX.utils.json_to_sheet(rows);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, ws, "Commission Ledger");
            XLSX.writeFile(wb, `Commission_Ledger_${fromDate}_to_${toDate}.xlsx`);

        } catch (err) {
            console.error("Excel download failed:", err);
            alert("Download failed");
        } finally {
            setDownloadLoader(false)
        }
    };


    return (
        <div className="bg-white rounded-xl shadow border p-5">

            {/* HEADER */}
            <div className="flex justify-between items-center mb-4">
                <h3 className="font-semibold text-lg text-[#0A2A4F]">
                    💰 Commission Ledger
                </h3>

                <div className="text-sm text-gray-500">
                    Total Records: <b>{totalElements}</b>
                </div>
            </div>

            {/* DATE FILTER */}
            <div className="grid md:grid-cols-4 gap-3 mb-4">

                <input
                    type="date"
                    value={fromDate}
                    max={today}
                    onChange={(e) => {
                        const selected = e.target.value;
                        setFromDate(selected);
                        if (toDate < selected) {
                            setToDate(selected);
                        }
                    }}
                    className="border rounded-lg px-3 py-2"
                />

                <input
                    type="date"
                    value={toDate}
                    min={fromDate}
                    max={today}
                    onChange={(e) => setToDate(e.target.value)}
                    className="border rounded-lg px-3 py-2"
                />
                {/* <button
                    onClick={() => fetchCommissionLedger(0)}
                    className="bg-blue-600 text-white rounded-lg px-4 py-2"
                >
                    Apply
                </button> */}

                {/* APPLY BUTTON WITH LOADER */}
                <button
                    onClick={() => fetchCommissionLedger(0, false, "apply")}
                    disabled={loading}
                    className={`bg-blue-600 text-white rounded-lg px-4 py-2 flex items-center justify-center gap-2 ${loading ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                >
                    {loading ? (
                        <>
                            <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
                            Applying...
                        </>
                    ) : (
                        "Apply"
                    )}
                </button>


                <button
                    onClick={() => {
                        setFromDate(today);
                        setToDate(today);
                        setTimeout(() => fetchCommissionLedger(0), 0);
                    }}
                    className="bg-gray-300 rounded-lg px-4 py-2"
                >
                    Reset
                </button>

                {/* <button
                    onClick={downloadExcel}
                    className="h-10 px-6 rounded-lg bg-green-600 text-white font-semibold
                 shadow hover:bg-green-700 transition"
                >
                    Download Excel
                </button> */}

                <button
                    onClick={downloadExcel}
                    disabled={downloadLoader}
                    className={`h-10 px-6 rounded-lg bg-green-600 text-white font-semibold shadow hover:bg-green-700 transition flex items-center justify-center gap-2 ${downloadLoader ? "opacity-60 cursor-not-allowed" : ""
                        }`}
                >
                    {downloadLoader ? (
                        <>
                            <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
                            Downloading...
                        </>
                    ) : (
                        "Download Excel"
                    )}
                </button>
                {/* </div> */}

            </div>

            {/* TABLE */}
            <div className="overflow-auto max-h-[65vh] border rounded-xl">
                <table className="w-full text-sm border-collapse">

                    <thead className="sticky top-0 bg-gray-100">
                        <tr>
                            {[
                                "Txn ID",
                                "Txn Date",
                                "Shop Name",
                                "Narration",
                                "Commission",
                                "TDS",
                                "Net Amount",
                                "Balance",
                            ].map((h) => (
                                <th key={h} className="px-3 py-2 border text-left">
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {history.length > 0 ? (
                            history.map((row, i) => (
                                <tr key={i} className="hover:bg-gray-50">

                                    <td className="px-3 py-2 border">{row.txnId}</td>
                                    <td className="px-3 py-2 border">{new Date(row.txnDate).toLocaleString("en-IN")}</td>
                                    <td className="px-3 py-2 border">{row.shopName}</td>
                                    <td className="px-3 py-2 border">{row.narration}</td>

                                    <td className="px-3 py-2 border">
                                        ₹{row.commission || 0}
                                    </td>

                                    <td className="px-3 py-2 border">
                                        ₹{row.tds || 0}
                                    </td>

                                    <td className="px-3 py-2 border">
                                        {formatNetAmount(row.netAmount || 0, row)}
                                    </td>

                                    <td className="px-3 py-2 border font-semibold">
                                        ₹{row.balance || 0}
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center py-6 text-gray-500">
                                    No Commission Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>

            {/* LOAD MORE */}
            <div className="flex justify-between items-center mt-4">

                <div className="text-sm text-gray-500">
                    Page: {page + 1} / {totalPages}
                </div>

                {page + 1 < totalPages && (
                    <button
                        onClick={() => fetchCommissionLedger(page + 1, true)}
                        disabled={loading}
                        className="px-5 py-2 bg-[#0A2A4F] text-white rounded-lg"
                    >
                        {loading ? "Loading..." : "Load More"}
                    </button>
                )}
            </div>

        </div>
    );
};

export default CommissionLedgerReport;